import { render, staticRenderFns } from "./subHeaderMobile.vue?vue&type=template&id=23571347&scoped=true&"
import script from "./subHeaderMobile.vue?vue&type=script&lang=js&"
export * from "./subHeaderMobile.vue?vue&type=script&lang=js&"
import style0 from "./subHeaderMobile.vue?vue&type=style&index=0&id=23571347&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23571347",
  null
  
)

export default component.exports